import React from "react";

function CouponFlash({ item }) {
  return (
    <>
      {item?.title && (
        <>
          <div className="marquee-child-item">
            <p className="text-md">{item?.title}</p>
          </div>
          <div className="marquee-child-item">
            <i className="icon-flash-star" />
          </div>
        </>
      )}
    </>
  );
}

export default CouponFlash;
